import React, { useEffect, useRef } from 'react';
import CommonItemFlag from 'components/common-item/CommonItemFlag';
import CommonItemInfo from 'components/common-item/CommonItemInfo';
import CommonItemTag from 'components/common-item/CommonItemTag';

const CraftBlockPredictionCombineList = ({ items, selectedPrizes, setSelectedPrizes, setOffsetCount }) => {

  const nextOffsetLoad = () => setOffsetCount((prev) => prev + 50);

  const getIsChecked = (id) => selectedPrizes.find((item) => item.id === id ? true : false);

  const addSelectedPrizes = (e, value, id, tag) => {
    if (tag !== 'Redeemable') {
      const matches = selectedPrizes.find((prize) => prize.id === id);

      if (!matches) {
        setSelectedPrizes((prevState) => [
          ...prevState,
          {
            id: id,
            cost: value
          }
        ]);
      } else if (matches) {
        setSelectedPrizes((prevState) =>
          prevState.filter((prize) => prize.id !== id)
        );
      }
    } else if (tag === 'Redeemable') {
      e.preventDefault();
    }
  };


  const targetRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            nextOffsetLoad();
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px', threshold: 0.1 }
    );

    if (items.length >= 6 && targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [items]);

  return (
    <ul className="cards-list__block cards-list__block--min cards-list__block--prediction-combine">
      {items.map((item, index) => {
        const isTargetElement = index === items.length - 6;

        return (
          <li
            key={item.id}
            ref={isTargetElement ? targetRef : null}
            className={`cards-list__block-item ${item.tag === "Redeemable" ? "disabled" : ""}`}
            onClick={(e) => {
              addSelectedPrizes(e, Number(item.name), item.id, item.tag);
            }}
          >
            <CommonItemInfo
              name={item.name}
              type={item.type}
              image={item.image}
              props={item.properties}
            />
            <p
              className={`cards-list__block-item-text ${
                item.tag !== "Redeemable"
                  ? "cards-list__block-item-text--select-mode"
                  : ""
              }`}
            >
              ${item.name}
              {item.tag !== "Redeemable" && (
                <>
                  <input
                    type="checkbox"
                    value={item.name}
                    checked={getIsChecked(item.id)}
                    id={item.id}
                  />
                  <label
                    htmlFor={item.id}
                    onClick={(e) => e.stopPropagation()}
                    className="cards-list__block-item-text-select"
                  ></label>
                </>
              )}
            </p>
            <CommonItemTag tag={item.tag} />
            <CommonItemFlag isListed={item.is_listed} isMine={item.owned_by_self} />
          </li>
        );
      })}
    </ul>
  );
};

export default CraftBlockPredictionCombineList;
